import { PredefinedDashboard } from '../widgetDashboard.enums'
import { WidgetDashboardConfig } from '../widgetDashboard.interface'
import DashboardWrapper from './DashboardWrapper'

export class Layout_h3 extends DashboardWrapper {
    constructor() {
        super(PredefinedDashboard.LAYOUT_H3)
        this.dashboardConfig = {
            name: 'Untitled',
            panes: {
                id: 1,
                space: 100,
                horizontal: true,
                panes: [{
                    id: 2,
                    space: 33.3,
                    horizontal: true,
                    panes: []
                }, {
                    id: 3,
                    space: 33.3,
                    horizontal: true,
                    panes: []
                }, {
                    id: 4,
                    space: 33.3,
                    horizontal: true,
                    panes: []
                }]
            },
            singleMode: false,
            widgets: {},
            syncSettings: {
                security: false,
                crosshair: false,
                time: false,
                timeBucket: false,
                drawing: false
            }
        } as WidgetDashboardConfig
    }
}